import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { cn } from '../lib/utils';
export type FAQItem = {
  q: string;
  a: string;
};
export function FAQ({
  items,
  light = false
}: {
  items: FAQItem[];
  light?: boolean;
}) {
  const [open, setOpen] = useState<number | null>(0);
  return <div className={cn('divide-y overflow-hidden rounded-xl border', light ? 'divide-cream/10 border-cream/15' : 'divide-navy/10 border-navy/10 bg-white')}
  // schema-ready: each item is a question/answer pair
  itemScope itemType="https://schema.org/FAQPage" data-id="element-53">
      {items.map((item, i) => {
      const isOpen = open === i;
      return <div key={item.q} itemScope itemProp="mainEntity" itemType="https://schema.org/Question" data-id="element-54">
            <button onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" aria-expanded={isOpen} data-id="element-55">
              <span itemProp="name" className={cn('font-medium', light ? 'text-cream' : 'text-navy')} data-id="element-56">
                {item.q}
              </span>
              <PlusIcon className={cn('h-5 w-5 shrink-0 transition-transform duration-200', light ? 'text-brass-light' : 'text-brass-dark', isOpen && 'rotate-45')} data-id="element-57" />
            </button>
            <AnimatePresence initial={false} data-id="element-58">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22
          }} className="overflow-hidden" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer" data-id="element-59">
                  <p itemProp="text" className={cn('px-5 pb-5 text-sm leading-relaxed', light ? 'text-cream/70' : 'text-ink/65')} data-id="element-60">
                    {item.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}